import React from 'react';
import {
  IBasicFilterFieldsFragment,
  IConditionFieldsFragment,
  IPredicateFieldsFragment,
} from '../../../../../../utils/apollo/graphqlSchema';
import DashboardFilterEditablePredicate from './DashboardFilterEditablePredicate';
import { useAppDispatch } from '../../../../../../redux/hooks';
import * as DashboardFilterViewUI from './DashboardFilterViewUI';
import { dashboardCustomizationSetFilter } from '../../../../../../redux/slices/dashboards/dashboardInstance';
import produce from 'immer';
import { assertCondition } from '../../../../../../utils/types';
import { removeWithLogicOps } from '../../../../../../components/FilterWidget/filterUtils';

interface IProps {
  filter: IBasicFilterFieldsFragment;
  condition: IConditionFieldsFragment;
  conditionIndex: number;
  includeAnyValue: boolean;
}

const DashboardFilterEditableCondition = ({
  filter,
  condition,
  conditionIndex,
  includeAnyValue,
}: IProps) => {
  const dispatch = useAppDispatch();

  const key = `basic-filter-field-view-${conditionIndex}`;
  const { predicates, logicOps: conditionLogicOps } = condition;

  const handleUpdatePredicate = (
    predicateIndex: number,
    newPredicate: IPredicateFieldsFragment,
  ) => {
    const newFilter = produce(filter, (draft) => {
      assertCondition(conditionIndex < draft.conditions.length);
      const condition = draft.conditions[conditionIndex];
      assertCondition(predicateIndex < condition.predicates.length);
      condition.predicates[predicateIndex] = newPredicate;
    });

    dispatch(
      dashboardCustomizationSetFilter({
        newFilter,
      }),
    );
  };

  const onRemovePredicate = (
    conditionIndex: number,
    predicateIndex: number,
  ) => {
    const newFilter = produce(filter, (draft) => {
      assertCondition(conditionIndex < draft.conditions.length);
      const condition = draft.conditions[conditionIndex];
      removeWithLogicOps(condition, 'predicates', predicateIndex);
    });

    dispatch(
      dashboardCustomizationSetFilter({
        newFilter,
      }),
    );
  };

  return (
    <DashboardFilterViewUI.Condition>
      <DashboardFilterViewUI.Bracket>(</DashboardFilterViewUI.Bracket>
      {predicates.map((predicate, predicateIndex) => (
        <DashboardFilterEditablePredicate
          key={`${key}-${conditionIndex}-${predicateIndex}`}
          predicate={predicate}
          logicOp={conditionLogicOps?.[predicateIndex]}
          keyPrefix={key}
          onRemovePredicate={() =>
            onRemovePredicate(conditionIndex, predicateIndex)
          }
          onChange={(predicate) =>
            handleUpdatePredicate(predicateIndex, predicate)
          }
          includeAnyValue={includeAnyValue}
        />
      ))}
      <DashboardFilterViewUI.Bracket>)</DashboardFilterViewUI.Bracket>
    </DashboardFilterViewUI.Condition>
  );
};

export default DashboardFilterEditableCondition;
